// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testMemeContainer {
    background-color: var(--ContainerBackgroung);
    width: 100%;
    border-radius: 5px;
}

.testMemeContent {
    padding: 1em;
}

.testMemeMessageText {
    padding: 2em;
    text-align: center;
    font-weight: bold;
    color: var(--settingsTextColor);
}

.testMemeBackButtonContainer {
    display: flex;
    justify-content: right;
    padding: 4px;
}

.testMemeBackBackButton {
    color: white;
    border: none;
    outline: none;
    background-color: var(--templatesColorBackgroundContainer);
    cursor: pointer;
}

.testMemeBackBackButton:hover {
    background-color: var(--templatesColorBackgroundInContainer);
}

.testMemeSelectionContainer {
    max-height: 420px;
    height: 420px;
}

.testMemeTitleSelection {
    text-align: center;
}

.testMemeImageLoaderImageDisplay {
    display: block;
    max-height: 5em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.testMemeImageLoaderImageContainerContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.8em;
    overflow: auto;
    max-height: 330px;
    background-color: var(--GrayBlue);
    padding-top: 1em;
    padding-bottom: 1em;
}

.testMemeLoadingText {
    text-align: center;
}

.testMemeContainerImage {
    max-height: 415px;
    height: 415px;
}

.testMemeImageLoaderImageContainer {
    display: flex;
    flex-direction: row;
    overflow: auto;
}

.testMemeImageLoaderImageContainer:hover {
    cursor: pointer;
    transform: scale(1.1);
}

.testMemeImageLoaderImageDisplaySelected {
    display: block;
    max-height: 10em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
    filter: drop-shadow(0 0 0.75rem var(--Gray));
}

.testMemeButtonContainerSelection {
    display: flex;
    flex-direction: column;
    padding-top: 1.5em;
    gap: 1em;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/TestMemeContainer/index.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,0DAA0D;IAC1D,eAAe;AACnB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".testMemeContainer {\n    background-color: var(--ContainerBackgroung);\n    width: 100%;\n    border-radius: 5px;\n}\n\n.testMemeContent {\n    padding: 1em;\n}\n\n.testMemeMessageText {\n    padding: 2em;\n    text-align: center;\n    font-weight: bold;\n    color: var(--settingsTextColor);\n}\n\n.testMemeBackButtonContainer {\n    display: flex;\n    justify-content: right;\n    padding: 4px;\n}\n\n.testMemeBackBackButton {\n    color: white;\n    border: none;\n    outline: none;\n    background-color: var(--templatesColorBackgroundContainer);\n    cursor: pointer;\n}\n\n.testMemeBackBackButton:hover {\n    background-color: var(--templatesColorBackgroundInContainer);\n}\n\n.testMemeSelectionContainer {\n    max-height: 420px;\n    height: 420px;\n}\n\n.testMemeTitleSelection {\n    text-align: center;\n}\n\n.testMemeImageLoaderImageDisplay {\n    display: block;\n    max-height: 5em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.testMemeImageLoaderImageContainerContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.8em;\n    overflow: auto;\n    max-height: 330px;\n    background-color: var(--GrayBlue);\n    padding-top: 1em;\n    padding-bottom: 1em;\n}\n\n.testMemeLoadingText {\n    text-align: center;\n}\n\n.testMemeContainerImage {\n    max-height: 415px;\n    height: 415px;\n}\n\n.testMemeImageLoaderImageContainer {\n    display: flex;\n    flex-direction: row;\n    overflow: auto;\n}\n\n.testMemeImageLoaderImageContainer:hover {\n    cursor: pointer;\n    transform: scale(1.1);\n}\n\n.testMemeImageLoaderImageDisplaySelected {\n    display: block;\n    max-height: 10em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n    filter: drop-shadow(0 0 0.75rem var(--Gray));\n}\n\n.testMemeButtonContainerSelection {\n    display: flex;\n    flex-direction: column;\n    padding-top: 1.5em;\n    gap: 1em;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
